import { UserManagementService } from '../../services/UserManagement.service'
import OktaUserDetails from "../../Helpers/OktaUserDetails"

const state = {
    tableData: [],
    headerData: [],
    healthPlanData: [],
    UserClientId: '',
    UserClientName: '',
    contractList: [],
    savecontractdetailsack: '',
    lastOktaUsersSyncDate: '',
}

const getters = {}

function getUserId() {
    return new OktaUserDetails().getUserId();
}
function getUserName() {
    return new OktaUserDetails().getUserName();
}

const actions = {
    getTableData({ commit }) {
        let params = 'userid=' + getUserId();
        return new Promise((resolve, reject) => {
            UserManagementService.getOktaUsers(
                params,
                oktaUsers => {
                    commit('setTableData', { oktaUsers: oktaUsers });
                    resolve()
                },
                err => {
                    reject(err)
                })
        })
    },

    syncUserDetailsFromOkta() {
        let params = 'userid=' + getUserId();
        return new Promise((resolve, reject) => {
            UserManagementService.syncUserDetailsFromOkta(
                params,
                () => {
                    resolve()
                },
                err => {
                    reject(err)
                })
        })
    },

    getAllHealthPlanNames({ commit }) {
        let params = 'userid=' + getUserId();
        return new Promise((resolve, reject) => {
            UserManagementService.getAllPlanNames(
                params,
                plannames => {
                    commit('setHealthPlanData', { plannames: plannames });
                    resolve()
                },
                err => {
                    reject(err)
                })
        })

    },

    getContractList({ commit }, { clientid }) {
        let params = 'ClientID=' + clientid + '&UserID=' + getUserId();
        return new Promise((resolve, reject) => {
            UserManagementService.getAllContractsForHealthPlan(
                params,
                contractlist => {
                    commit('setContractList', { contractlist: contractlist });
                    resolve()
                },
                err => {
                    reject(err)
                })
        })

    },

    saveContractDetails({ commit }, { clientid, contractlist, userid }) {
        const params = {
            "UserID": userid,
            "UpdatedBy": getUserId(),
            "ClientId": clientid.clientID,
            "Contracts":
                contractlist
        }
        return new Promise((resolve, reject) => {
            UserManagementService.saveContractDetails(
                params,
                savecontractdetails => {
                    commit('savecontractData', { savecontractdetails });
                    resolve()
                },
                err => {
                    reject(err)
                })
        })
    },

    resetSelectedContract({ commit }) {

        commit('resetcontractData');
    },

    getUserClientDetails({ commit }) {

        let param = 'userid=' + getUserId();

        return new Promise((resolve, reject) => {
            UserManagementService.getUserClientDetails(
                param,
                clientDetails => {
                    commit('setUserClientDetails', { clientDetails });
                    resolve()
                },
                err => {
                    reject(err)
                })
        })
    }

}

const mutations = {
    setTableData(state, { oktaUsers }) {
        state.tableData = oktaUsers.tableData;
        state.headerData = oktaUsers.headerData;
        state.lastOktaUsersSyncDate = oktaUsers.lastOktaUsersSyncDate;
    },
    setHealthPlanData(state, { plannames }) {
        state.healthPlanData = plannames;
    },

    setContractList(state, { contractlist }) {
        state.contractList = contractlist;
    },

    savecontractData(state, { savecontractdetails }) {
        state.userSettingDataAck = savecontractdetails;
    },
    resetcontractData(state) {
        state.contractList = [];
    },
    setHealthPlanData(state, { plannames }) {
        state.healthPlanData = plannames;
    },

    setContractList(state, { contractlist }) {
        state.contractList = contractlist;
    },

    saveContractData(state, { savecontractdetails }) {
        state.userSettingDataAck = savecontractdetails;
    },

    setUserClientDetails(state, { clientDetails }) {
        state.UserClientId = clientDetails.clientID;
        state.UserClientName = clientDetails.clientName;
    },
    resetContractData(state) {
        state.contractList = [];
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}